import { render, staticRenderFns } from "./p14.vue?vue&type=template&id=3876232d&scoped=true&"
import script from "./p14.vue?vue&type=script&lang=js&"
export * from "./p14.vue?vue&type=script&lang=js&"
import style0 from "./p14.vue?vue&type=style&index=0&id=3876232d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3876232d",
  null
  
)

export default component.exports